import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import LayoutAuth from '../../components/LayoutAuth';
import FormSingUp from './components/FormSingUp';

const SingUp = () => {
  const { t } = useTranslation();
  return (
    <LayoutAuth
      linkHelper="/login"
      linkHelperMessage={t('sign_up.linkHelperMessage')}
      linkHelperText={t('sign_up.linkHelperText')}
      title={t('sign_up.title')}
    >
      <FormSingUp />
    </LayoutAuth>
  );
};
export default SingUp;
